module.exports = __webpack_public_path__ + "static/media/Magicline.d452f6aa.png";